/**
 * Constants for ApplicationInfo component
 */

// File upload constraints
export const MAX_FILE_SIZE = 500 * 1024; // 500 KB
export const ACCEPTED_IMAGE_TYPES = "image/png, image/jpeg, image/webp";

// Image dimensions
export const IMAGE_DIMENSIONS = {
  icon: { width: 55, height: 55 },
  pdfCover: { width: 210, height: 297 },
  pdfInfo: { width: 210, height: 297 },
};

// Default editor content
export const DEFAULT_EDITOR_HTML = "<p> Uygulama bilgilendirme sayfası içeriğini giriniz</p>";
